import type { HashData, FormData } from '../types'

export function encodeHashData(templateId: string, data: FormData): string {
  const hashData: HashData = { templateId, data }
  const json = JSON.stringify(hashData)
  const base64 = btoa(unescape(encodeURIComponent(json)))
  return base64
}

export function decodeHashData(hash: string): HashData | null {
  try {
    const base64 = hash.startsWith('#data=') ? hash.slice(6) : hash
    const json = decodeURIComponent(escape(atob(base64)))
    return JSON.parse(json) as HashData
  } catch {
    return null
  }
}

export function generatePrivacySafeLink(
  baseUrl: string,
  templateId: string,
  data: FormData
): string {
  const encoded = encodeHashData(templateId, data)
  return `${baseUrl}/sign/${templateId}#data=${encoded}`
}
